import { TableCell } from '@tiptap/extension-table-cell'

export const CustomTableCell = TableCell.extend({
  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement('td')
      const wrapper = document.createElement('div')

      // You can add custom wrapper classes or attributes here
      if (node.attrs.colspan) {
        dom.setAttribute('colspan', node.attrs.colspan)
      }
      if (node.attrs.rowspan) {
        dom.setAttribute('rowspan', node.attrs.rowspan)
      }
      if (node.attrs.colWidth) {
        dom.style.width = node.attrs.colWidth
      }

      dom.classList.add('rt-table-cell')
      wrapper.classList.add('rt-table-cell-wrapper')
      dom.appendChild(wrapper)
      return {
        dom,
        contentDOM: wrapper,
      }
    }
  },
})
